export const GroupDescInitValue = 'Loading...'
export const GroupCreatedTimestampInitValue = -1
export const GroupMembersCountInitValue = -1
export const GroupDescEmptyString = 'Empty...'
